import { combineReducers, applyMiddleware } from 'redux'

import { configureStore } from '@reduxjs/toolkit';

import { currentflowReducer } from './reducers/flowReducers'


const reducer = combineReducers({

    currentflowR: currentflowReducer,
})



const initialState = {

   
} 

const store = configureStore({reducer:reducer, initialState}); //, devTools);


export default store